import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button, Input, Label } from '@dgm/ui';
import { api, ApiError } from '../lib/api.js';
import { AuthCard } from '../components/AuthCard.js';

export function VerifyPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const email = params.get('email') ?? '';
  const [code, setCode] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [info, setInfo] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await api.post('/auth/verify', { email, code });
      navigate('/login');
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Verification failed.');
    } finally {
      setBusy(false);
    }
  }

  async function resend() {
    setError(null);
    setInfo(null);
    try {
      await api.post('/auth/resend', { email });
      setInfo('A new code is on its way.');
    } catch {
      setInfo('A new code is on its way.');
    }
  }

  return (
    <AuthCard title="Verify your email" description={`We sent a 6-digit code to ${email}.`}>
      <form onSubmit={submit} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="code">Verification code</Label>
          <Input
            id="code"
            inputMode="numeric"
            maxLength={6}
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="123456"
          />
        </div>
        {error ? <p className="text-sm text-destructive">{error}</p> : null}
        {info ? <p className="text-sm text-muted-foreground">{info}</p> : null}
        <Button type="submit" className="w-full" disabled={busy}>
          {busy ? 'Verifying…' : 'Verify'}
        </Button>
        <Button type="button" variant="ghost" className="w-full" onClick={resend}>
          Resend code
        </Button>
      </form>
    </AuthCard>
  );
}
